module.exports = __webpack_public_path__ + "static/img/2_10_1.b44339bd.jpg";